/**
 * Pure helpers for the export drill-down view (build plan §1.6).
 * Extracted for testability — no React, no Firebase.
 */

/**
 * Group subjects by project for the export drill-down.
 * A subject in multiple projects appears in each project folder.
 * Projects sorted by project.number; subjects within each group sorted by
 * subject.number.
 *
 * Returns { projects: [{ project, subjects, exportCount }],
 *           noProject: { subjects, exportCount } }.
 */
export function groupSubjectsByProject(subjects, projects) {
  const sorted = [...projects].sort((a, b) => (a.number ?? 0) - (b.number ?? 0));
  const projectGroups = sorted.map((project) => {
    const projSubjects = subjects
      .filter((s) => (s.projectIds ?? []).includes(project.id))
      .sort((a, b) => (a.number ?? 0) - (b.number ?? 0));
    const exportCount = projSubjects.reduce(
      (sum, s) => sum + (s.exports?.length ?? 0), 0,
    );
    return { project, subjects: projSubjects, exportCount };
  });

  // Empty placeholders (no raw, no project, no exports) are not exportable —
  // the old flat picker excluded them and the drill-down must too.
  const noProjectSubjects = subjects
    .filter((s) => !(s.projectIds?.length) && (s.rawSets?.length || s.exports?.length))
    .sort((a, b) => (a.number ?? 0) - (b.number ?? 0));
  const noProjectExportCount = noProjectSubjects.reduce(
    (sum, s) => sum + (s.exports?.length ?? 0), 0,
  );

  return {
    projects: projectGroups,
    noProject: { subjects: noProjectSubjects, exportCount: noProjectExportCount },
  };
}

/**
 * Default tethered tool code for a project's software.
 * Reverse of SOFTWARE_FOR_CODE, matched against the TETHERED gear list.
 */
export function defaultToolForSoftware(software, tetheredGear) {
  const match = tetheredGear.find((t) => t.software === software);
  return match?.code ?? tetheredGear[0]?.code ?? "sps";
}
